<template>
    <div
        :class="{
            'coupon-card': true,
            'coupon-card-selected': selected,
        }"
        @click="handleClick"
    >
        <div v-if="isForSale" class="coupon-card-tag">超值特惠</div>
        <div class="coupon-card-content">
            <div class="coupon-count">
                <span class="coupon-icon"></span>
                <span>{{ data.oriPrice }}</span>

            </div>
            <div class="coupon-price">
                <span>¥</span>
                <span>{{ data.sellPrice }}</span>
            </div>
            <div v-if="isForSale" class="coupon-original-price">
                <span>¥{{ data.oriPrice }}</span>
            </div>
        </div>
        <div class="coupon-footer">
            {{ data.skuName }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'CouponPayCard',
    components: {
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 组件的初始数据
        };
    },
    computed: {
        isForSale() {
            return this.data.oriPrice > this.data.sellPrice;
        }
    },
    methods: {
        handleClick() {
            this.$emit('check', this.data);
        }
    }

};
</script>

<style scoped lang="less">
.coupon-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 144px;
    height: 169px;
    position: relative;
    background: #FFFBF8;
    border: 1.5px solid #FFDBBE;
    border-radius: 10px;
    user-select: none;
    .coupon-card-tag {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        position: absolute;
        width: 56px;
        height: 18px;
        left: -1px;
        top: -1px;

        background: linear-gradient(86.42deg, #F7B225 0%, #F67272 100%);
        border-radius: 10px 6px 6px 0px;
        font-size: 10px;
        color: #FFFFFF;
    }
    &-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        flex: 1;
        padding: 24px 24px 0px;
    }
    .coupon-count {
        display: flex;
        align-items: center;
        gap: 4px;
        height: 20px;

        font-family: "Baidu Number Plus", "Baidu Number";
        font-weight: 500;
        font-size: 16px;
        /* 功能色/黄/黄-active-W8 */
        color: #D88F00;
    }
    .coupon-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(https://qiaojiang.bj.bcebos.com/fe/iconGoldenDiamond_72x72.png) no-repeat;
        background-size: 100%;
    }
    .coupon-price {
        display: flex;
        justify-content: center;
        align-items: baseline;
        gap: 4px;
        height: 39px;
        font-family: "Baidu Number Plus", "Baidu Number";
        font-size: 24px;
        font-weight: 500;

    }
    .coupon-original-price {
        height: 16px;
        font-family: "Baidu Number Plus", "Baidu Number";
        font-weight: 500;
        font-size: 12px;
        color: #848B99;
        position: relative;
        line-height: 16px;
        vertical-align: middle;
        &::before {
            content:'';
            display: inline-block;
            height: 1px;
            width: 100%;
            background: #848B99;
            position: absolute;
            top: 8px;
        }
    }
    .coupon-footer {
        width: 100%;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #D88F00;
        border-radius: 0 0 10px 10px;
        background: linear-gradient(
            267.45deg,
            rgba(255, 227, 174, 0.5) 0%,
            rgba(255, 244, 222, 0.5) 48.25%,
            rgba(253, 239, 197, 0.5) 96.13%
        );
        //styleName: T2 小标题/medium;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
    }

    &-selected {
        background: url('../../assets/selectedCouponCardBg.png') no-repeat;
        background-size: 100%;
        border-color: #F5C096;
        .coupon-footer {
            background: linear-gradient(267.45deg, #FFE1A5 0%, #FFF0D2 46.62%, #FFE4AF 96.13%);
        }
    }

}
</style>